<template>
  <b-row class="p-3 pr-5">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <PageTitle title="Enviar notificações pelo meu whatsapp" />
    </div>

    <div class="col-12 box mt-4 mb-4 pb-4">
      <b-row>
        <div class="col-12 text-center">
          <h4>Envie todas notificações do seu aplicativo/site pelo WhatsApp da sua loja</h4>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center mt-4">
          <button
            class="btn btn-success btn-block mt-2"
            :disabled="reload" v-if="whatsapp == false"
            @click="connectionWhatsApp()"
          >
            {{reload == true ? 'Conectando...' : 'Ativar WhatsApp'}}
          </button>

          <button
            class="btn btn-danger btn-block"
            v-if="whatsapp == true && this.reload == false"
            @click="logoutConnectionWhatsapp()"
          >
            Desativar WhatsApp
          </button>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center">
          <h4 v-if="qrCode != ''" class="mt-4">QR-Code para conectar WhatsApp</h4>
          <qrcode-vue
            v-if="qrCode != ''"
            class="mt-2"
            :value="qrCode"
            size=200
            level="H"
          />

          <button
            v-if="reload == true"
            class="btn btn-primary btn-block mt-4"
            @click="connectionWhatsApp()"
          >
            Buscar novo Qr-Code
          </button>

          <div class="alert alert-warning btn-pisca mt-3" role="alert" v-if="reload == true">
            Aguardando leitura do QR-Code!
          </div>

          <div class="alert alert-success mt-4" role="alert" v-if="connect == true">
            Seu WhatsApp está conectado!
          </div>

          <div class="alert alert-danger mt-4" role="alert" v-if="connect == false && reload == false">
            Seu WhatsApp está desconectado!
          </div>
        </div>
      </b-row>
    </div>

    <div class="col-12 box mt-4 pb-4" v-if="connect == true">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-uppercase mt-4">
          <h4><b>Enviar mensagens com o WhatsApp</b></h4>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-4">
          <label>Números do WhatsApp:</label>
          <a href="https://construp-imagens.s3.us-east-2.amazonaws.com/Planilha+WhatsApp.xlsx" class="ml-2">Baixar planilha modelo</a>
          <b-row
            class="align-items-center border-r5 p-2 pointer"
            style="border: 1px dashed #28a745; background-color: #eee; width:100%"
          >
            <div class="col-10">
              <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="handleFileUpload">
            </div>
            <div class="text-right">
              <i class="fas fa-cloud-upload-alt fs-30 text-success"></i>
            </div>
          </b-row>
        </div>

        <div class="col-12 mt-4">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div class="row">
                <div class="col-12">
                  <label>Tipo de envio</label>
                  <select class="form-control" v-model="data.type">
                    <option value="">-- Selecione --</option>
                    <option value="1">Enviar somente texto</option>
                    <option value="2">Enviar imagem com texto (Opcional)</option>
                    <option value="3">Enviar PDF com texto (Opcional)</option>
                    <option value="4">Enviar video com texto (Opcional)</option>
                    <option value="5">Enviar áudio sem texto</option>
                  </select>
                </div>

                <div class="col-12 mt-3" v-if="data.type != '1' && data.type != ''">
                  <label>Arquivo: (documento / imagem / vídeo / áudio)</label>
                  <input type="file" ref="file" class="form-control" @change="convertFileBase64">
                </div>

                <div class="col-12 mt-3" v-if="data.type != '5'">
                  <label>Mensagem: {{data.type == '1' ? '' : '(Opcional)'}}</label>
                  <textarea class="form-control" rows="4" v-model="data.msg"></textarea>
                </div>

                <div class="col-12 mt-3">
                  <label class="m-0">Agendar envio: (Opcional)</label><br>
                  <input type="checkbox" v-model="data.scheduleShipping">
                </div>

                <div class="col-12 mt-2" v-if="data.scheduleShipping">
                  <label>Data do envio:</label>
                  <input type="datetime-local" class="form-control" v-model="data.date">
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div class="row">
                <div class="col-12 mt-4">
                  <span style="color:red">
                    Os números tem q ter o DDD+NUMERO, EX: 19999999999
                  </span>
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th class="text-left">Número (numero)</th>
                        <th class="text-left">Nome (nome) Opcional</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in numeros" :key="i">
                        <td class="text-left">{{item.numero ? item.numero : '-'}}</td>
                        <td class="text-left">{{item.nome ? item.nome : '-'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 text-center mt-4">
          <button
            class="btn btn-success pr-5 pl-5 pt-2 pb-2"
            :disabled="
              data.type == '' ||
              numeros.length == 0 ||
              (data.type == '1' && data.msg == '') ||
              (data.type != '1' && data.file == '') ||
              (data.scheduleShipping && data.date == '')
            "
            @click="sendMessage()"
          >
            Enviar WhatsApp
          </button>
        </div>
      </div>
    </div>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import * as XLSX from 'xlsx';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'ListNotificationsWhatsApp',
  mixins: [makeToast],

  components: {
    PageTitle,
    QrcodeVue
  },

  data() {
    return {
      whatsapp: false,
      qrCode: '',
      reload: false,
      connect: false,
      numeros: [],
      data: {
        type: '',
        file: '',
        msg: '',
        scheduleShipping: false,
        date: ''
      }
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.statusWhatsApp();
  },

  methods: {
    ...mapActions('shopkeeper', [
      'getStatusWhatsApp',
      'initConnectionWhatsApp',
      'deleteConnectionWhatsapp',
      'newMessageWhatsApp'
    ]),
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          this.numeros = jsonData;
        };
        reader.readAsBinaryString(file);
      }
    },
    convertFileBase64(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.data.file = e.target.result;
        };

        reader.readAsDataURL(file);
      }
    },
    sendMessage() {
      if(this.data.type == '1') {
        this.data.file = '';
      }

      let numerosSend = null;
      if(this.data.scheduleShipping) {
        numerosSend = this.numeros.splice(0, this.numeros.length);
      } else {
        this.data.date = '';
        numerosSend = this.numeros.splice(0, 20);
      }

      const data = {
        lojistaId: this.dadosUsuario.id,
        data: this.data,
        numeros: numerosSend
      }

      this.$store.dispatch('startLoader');
      this.newMessageWhatsApp(data)
        .then((response) => {
          if(response.data.error == true) {
            this.$store.dispatch('endLoader');
            this.makeToast('Opss', 'Houve um erro ao enviar a mensagem!', 'danger');
            return;
          }

          if(this.numeros.length > 0) {
            setTimeout(() => {
              this.sendMessage();
            }, 2000);
          } else {
            this.$store.dispatch('endLoader');
            this.makeToast('Sucesso', 'Mensagem enviada com sucesso!', 'success');

            this.numeros = [];
            this.data.type = '';
            this.data.scheduleShipping = false;
            this.data.date = '';
            this.data.file = '';
            this.data.msg = '';
          }
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Opss', 'Houve um erro ao enviar a mensagem!', 'danger');
        });
    },
    statusWhatsApp() {
      this.$store.dispatch('startLoader');
      this.getStatusWhatsApp(this.dadosUsuario.id)
        .then((response) => {
          if(response.data.status == 'open') {
            this.whatsapp = true;
            this.connect = true;
            return;
          }

          this.makeToast('Atenção', response.data.msg, 'warning');
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao trazer os dados!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    logoutConnectionWhatsapp() {
      this.$store.dispatch('startLoader');
        this.deleteConnectionWhatsapp(this.dadosUsuario.id)
          .then((response) => {
            if(response.data.error == true) {
              this.makeToast('Atenção', response.data.msg, 'danger');
              return;
            }

            this.whatsapp = false;
            this.qrCode = '';
            this.reload = false;
            this.connect = false;

            this.statusWhatsApp();

            this.makeToast('Sucesso', response.data.msg, 'success');
          })
          .catch(() => {
            this.makeToast('Opss', 'Houve um erro ao trazer os dados!', 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
    },
    checkStatusWhatsApp() {
      this.getStatusWhatsApp(this.dadosUsuario.id)
        .then((response) => {
          this.whatsapp = false;
          if(response.data.status == 'open') {
            this.whatsapp = true;
            this.connect = true;
            this.reload = false;
            this.qrCode = '';
            this.makeToast('Sucesso', 'WhatsApp conectado com sucesso!', 'success');
          } else {
            console.log('WhatsApp desconectado!');
            setTimeout(() => {
              this.checkStatusWhatsApp();
            }, 3000);
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao trazer os dados!', 'danger');
        });
    },
    connectionWhatsApp() {
      this.qrCode = '';
      this.$store.dispatch('startLoader');
      this.initConnectionWhatsApp(this.dadosUsuario.id)
        .then((response) => {
          if(response.data.error == true) {
            this.makeToast('Opss', 'Houve um erro ao tentar conectar ao WhatsApp!', 'danger');
            return;
          }

          this.whatsapp = true;
          this.reload = true;

          this.qrCode = response.data.code;

          this.checkStatusWhatsApp();
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao tentar conectar ao WhatsApp!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
  },
};
</script>

<style scoped>
 @keyframes btn-pisca {
    0% { opacity: 0; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
 }
.btn-pisca {
  -webkit-animation: btn-pisca .9s linear infinite;
  -moz-animation: btn-pisca .9s linear infinite;
  -ms-animation: btn-pisca .9s linear infinite;
  -o-animation: btn-pisca .9s linear infinite;
  animation: btn-pisca .9s linear infinite;
}
.box {
  box-shadow: 0 2px 2px rgba(109, 109, 109, 0.1), 0 2px 2px rgba(119, 119, 119, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}
#inseridos tr td, #inseridos tr th {
  border: 2px solid green !important;
}

#naoinseridos tr td, #naoinseridos tr th {
  border: 2px solid red !important;
}
</style>
